<div class="payroll-config-wrap" *ngIf="form">
    <ul class="nav employee-main-tabs">
        <li class="nav-item flex-fill">
            <button type="button" class="nav-link w-100" [class.active]="activeTab === 'generales'" (click)="setTab('generales')">
                <img class="main-tab-icon" src="assets/img/icons/tab-configuration-02.svg" alt="">
                <span>Generales</span>
            </button>
        </li>
        <li class="nav-item flex-fill">
            <button type="button" class="nav-link w-100" [class.active]="activeTab === 'cuotas_imss'" (click)="setTab('cuotas_imss')">
                <img class="main-tab-icon" src="assets/img/icons/tab-imss.svg" alt="">
                <span>Cuotas de IMSS</span>
            </button>
        </li>
        <li class="nav-item flex-fill">
            <button type="button" class="nav-link w-100" [class.active]="activeTab === 'retencion_imss'" (click)="setTab('retencion_imss')">
                <img class="main-tab-icon" src="assets/img/icons/tab-imss.svg" alt="">
                <span>Retención IMSS</span>
            </button>
        </li>
        <li class="nav-item flex-fill">
            <button type="button" class="nav-link w-100" [class.active]="activeTab === 'credito_infonavit'" (click)="setTab('credito_infonavit')">
                <img class="main-tab-icon" src="assets/img/icons/tab-scroll.svg" alt="">
                <span>Crédito INFONAVIT</span>
            </button>
        </li>
    </ul>

    <div class="payroll-config-panel" *ngIf="activeTab === 'cuotas_imss'">
        <div class="payroll-config-header">
            <h4 class="mb-0">Configuración de Cuotas de IMSS</h4>
            <p class="mb-0">Define las cuotas y porcentajes utilizados para el calculo de la nomina</p>
        </div>

        <table class="imss-rates-table">
            <thead>
                <tr>
                    <th>Descripción del seguro</th>
                    <th class="text-center">Tope (GT)</th>
                    <th class="text-center">% Patrón</th>
                    <th class="text-center">% Obrero</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let rate of imssRatesUngrouped">
                    <td>{{rate.label}}</td>
                    <td class="text-center">
                        <span class="imss-rate-value">{{rate.contribution_cap_gt | number:'1.4-4'}} <img src="assets/img/icons/imss-lock.svg" alt=""></span>
                    </td>
                    <td class="text-center">
                        <span class="imss-rate-value" *ngIf="rate.patronal_percentage !== null">{{rate.patronal_percentage | number:'1.4-4'}} <img src="assets/img/icons/imss-lock.svg" alt=""></span>
                        <span class="imss-rate-empty" *ngIf="rate.patronal_percentage === null">--</span>
                    </td>
                    <td class="text-center">
                        <span class="imss-rate-value" *ngIf="rate.obrero_percentage !== null">{{rate.obrero_percentage | number:'1.4-4'}} <img src="assets/img/icons/imss-lock.svg" alt=""></span>
                        <span class="imss-rate-empty" *ngIf="rate.obrero_percentage === null">--</span>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="imss-rates-group" *ngIf="imssRatesGrouped.length">
            <div class="imss-rates-group-header" (click)="toggleImssGroup()">
                <span>{{imssGroupLabel}}</span>
                <img src="assets/img/icons/imss-chevron-up.svg" alt="" [class.rotated]="!imssGroupExpanded">
            </div>
            <table class="imss-rates-table imss-rates-table-grouped" *ngIf="imssGroupExpanded">
                <tbody>
                    <tr *ngFor="let rate of imssRatesGrouped">
                        <td>{{rate.label}}</td>
                        <td class="text-center">
                            <span class="imss-rate-value">{{rate.contribution_cap_gt | number:'1.4-4'}} <img src="assets/img/icons/imss-lock.svg" alt=""></span>
                        </td>
                        <td class="text-center">
                            <span class="imss-rate-value" *ngIf="rate.patronal_percentage !== null">{{rate.patronal_percentage | number:'1.4-4'}} <img src="assets/img/icons/imss-lock.svg" alt=""></span>
                            <span class="imss-rate-empty" *ngIf="rate.patronal_percentage === null">--</span>
                        </td>
                        <td class="text-center">
                            <span class="imss-rate-value" *ngIf="rate.obrero_percentage !== null">{{rate.obrero_percentage | number:'1.4-4'}} <img src="assets/img/icons/imss-lock.svg" alt=""></span>
                            <span class="imss-rate-empty" *ngIf="rate.obrero_percentage === null">--</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="payroll-config-panel" *ngIf="activeTab === 'retencion_imss'" [formGroup]="form">
        <div class="tab-card">
            <div class="tab-card-header">
                <span class="tab-icon-badge" style="background:#eee7fe;"><img src="assets/img/icons/imss-calculator.svg" alt=""></span>
                <h5>Forma de cálculo del SDI</h5>
            </div>
            <p class="imss-card-subtitle">Selecciona la fuente de Salario Diario que se utilizaria para el cálculo</p>

            <div class="field-col">
                <label class="field-label">Tipo de forma</label>
                <select class="field-select" formControlName="sdi_calculation_source">
                    <option value="manual_sdi">SDI actualizado manualmente</option>
                </select>
            </div>
        </div>

        <div class="cfg-row cfg-row-2">
            <div class="tab-card">
                <div class="tab-card-header">
                    <span class="tab-icon-badge" style="background:#fef3d4;"><img src="assets/img/icons/imss-security-check.svg" alt=""></span>
                    <h5>Validar para retención IMSS</h5>
                </div>

                <label class="imss-radio-row">
                    <input type="radio" formControlName="imss_retention_validation_base" value="daily_salary">
                    <span>
                        <strong>El salario diario</strong>
                        <small>Se valida y retiene en base al salario diario</small>
                    </span>
                </label>
                <label class="imss-radio-row">
                    <input type="radio" formControlName="imss_retention_validation_base" value="total_earnings">
                    <span>
                        <strong>El Total de percepciones</strong>
                        <small>Se valida y retiene en base al total de percepciones</small>
                    </span>
                </label>
            </div>

            <div class="tab-card">
                <div class="tab-card-header">
                    <span class="tab-icon-badge" style="background:#e8fcf7;"><img src="assets/img/icons/imss-calendar.svg" alt=""></span>
                    <h5>Días a considerar para parte variable de SDI</h5>
                </div>

                <label class="imss-radio-row">
                    <input type="radio" formControlName="sdi_variable_days_basis" value="worked_days_accumulated">
                    <span>
                        <strong>Acumulado de días trabajados</strong>
                        <small>Se consideran los acumulados de días del periodo</small>
                    </span>
                </label>
                <label class="imss-radio-row">
                    <input type="radio" formControlName="sdi_variable_days_basis" value="calendar_days">
                    <span>
                        <strong>Días calendario</strong>
                        <small>Se consideran los dias calendario del periodo</small>
                    </span>
                </label>
            </div>
        </div>

        <label class="imss-checkbox-row">
            <input type="checkbox" formControlName="discount_absences_sickness_maternity">
            <span>
                <strong>Descuenta faltas / ausentismo para enfermedad y maternidad</strong>
                <small>Al calcular el SDI para enfermedad y maternidad, se descontarán las faltas o ausentismos registrados</small>
            </span>
        </label>

        <div class="doc-info-banner">
            <img src="assets/img/icons/imss-info.svg" alt="">
            <p>Estos parametros determinan la forma de retención de la cuota del IMSS de los trabajadores. Los cambios aplicaran en el proximo cálculo de nómina.</p>
        </div>

        <div class="tab-save-bar" *ngIf="canDo('Editar')">
            <button type="button" class="btn btn-primary" (click)="save()">Guardar cambios</button>
        </div>
    </div>

    <div class="payroll-config-panel" *ngIf="activeTab === 'credito_infonavit'" [formGroup]="form">
        <div class="tab-card">
            <div class="tab-card-header">
                <h5>Parámetros para el cálculo de amortización</h5>
            </div>
            <div class="cfg-row cfg-row-2">
                <div class="field-col">
                    <label class="field-label">UMI (Unidad de Medida y Actualización)</label>
                    <div class="field-input-icon">
                        <input type="number" step="0.01" class="field-input" formControlName="infonavit_umi">
                        <img src="assets/img/icons/infonavit-calculator.svg" alt="">
                    </div>
                </div>
                <div class="field-col">
                    <label class="field-label">Calendario bimestral</label>
                    <select class="field-select" formControlName="infonavit_bimonthly_calendar">
                        <option [ngValue]="null">Seleccionar</option>
                        <option *ngFor="let n of bimonthlyCalendarOptions" [ngValue]="n">{{n}}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="tab-card">
            <div class="tab-card-header">
                <h5>Seguro de daños de vivienda</h5>
            </div>
            <div class="field-col" style="max-width: 240px;">
                <label class="field-label">Monto</label>
                <div class="field-input-icon">
                    <input type="number" step="0.01" class="field-input" formControlName="housing_damage_insurance_amount">
                    <img src="assets/img/icons/infonavit-calculator.svg" alt="">
                </div>
            </div>
        </div>

        <div class="tab-card">
            <div class="tab-card-header">
                <h5>Validación de salario mínimo en amortización</h5>
            </div>
            <div class="cfg-row cfg-row-3">
                <label class="imss-checkbox-row">
                    <input type="radio" formControlName="infonavit_min_wage_validation" value="daily_salary">
                    <span>
                        <strong>Salario diario</strong>
                        <small>Se valida contra el salario mínimo diario.</small>
                    </span>
                </label>
                <label class="imss-checkbox-row">
                    <input type="radio" formControlName="infonavit_min_wage_validation" value="total_earnings">
                    <span>
                        <strong>Total de percepciones</strong>
                        <small>Se valida contra el total de percepciones.</small>
                    </span>
                </label>
                <label class="imss-checkbox-row">
                    <input type="radio" formControlName="infonavit_min_wage_validation" value="none">
                    <span>
                        <strong>No aplicar validación</strong>
                        <small>No se validará contra el salario mínimo.</small>
                    </span>
                </label>
            </div>
        </div>

        <div class="tab-card">
            <label class="imss-checkbox-row">
                <input type="checkbox" formControlName="infonavit_discount_by_absence_type_enabled">
                <strong>Configurar faltas por tipo de descuento (Art. 29 LINFONAVIT)</strong>
            </label>

            <div class="infonavit-discount-fields" *ngIf="form.get('infonavit_discount_by_absence_type_enabled')?.value">
                <div class="infonavit-discount-row">
                    <span class="infonavit-discount-label">Porcentaje</span>
                    <div class="infonavit-dropdown">
                        <button type="button" class="infonavit-dropdown-trigger" (click)="toggleDropdown('infonavit_absence_percentage_types')">
                            {{selectedCountLabel('infonavit_absence_percentage_types')}}
                            <img src="assets/img/icons/infonavit-chevron-down.svg" alt="">
                        </button>
                        <div class="infonavit-dropdown-panel" *ngIf="isDropdownOpen('infonavit_absence_percentage_types')">
                            <label class="infonavit-dropdown-option" *ngFor="let opt of discountTypeOptions">
                                <input type="checkbox" [checked]="isDiscountTypeSelected('infonavit_absence_percentage_types', opt)" (change)="toggleDiscountType('infonavit_absence_percentage_types', opt)">
                                {{opt}}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="infonavit-discount-row">
                    <span class="infonavit-discount-label">Cuota fija en pesos</span>
                    <div class="infonavit-dropdown">
                        <button type="button" class="infonavit-dropdown-trigger" (click)="toggleDropdown('infonavit_absence_fixed_amount_types')">
                            {{selectedCountLabel('infonavit_absence_fixed_amount_types')}}
                            <img src="assets/img/icons/infonavit-chevron-down.svg" alt="">
                        </button>
                        <div class="infonavit-dropdown-panel" *ngIf="isDropdownOpen('infonavit_absence_fixed_amount_types')">
                            <label class="infonavit-dropdown-option" *ngFor="let opt of discountTypeOptions">
                                <input type="checkbox" [checked]="isDiscountTypeSelected('infonavit_absence_fixed_amount_types', opt)" (change)="toggleDiscountType('infonavit_absence_fixed_amount_types', opt)">
                                {{opt}}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="infonavit-discount-row">
                    <span class="infonavit-discount-label">Cuota fija en veces S.M.</span>
                    <div class="infonavit-dropdown">
                        <button type="button" class="infonavit-dropdown-trigger" (click)="toggleDropdown('infonavit_absence_fixed_sm_types')">
                            {{selectedCountLabel('infonavit_absence_fixed_sm_types')}}
                            <img src="assets/img/icons/infonavit-chevron-down.svg" alt="">
                        </button>
                        <div class="infonavit-dropdown-panel" *ngIf="isDropdownOpen('infonavit_absence_fixed_sm_types')">
                            <label class="infonavit-dropdown-option" *ngFor="let opt of discountTypeOptions">
                                <input type="checkbox" [checked]="isDiscountTypeSelected('infonavit_absence_fixed_sm_types', opt)" (change)="toggleDiscountType('infonavit_absence_fixed_sm_types', opt)">
                                {{opt}}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="tab-save-bar" *ngIf="canDo('Editar')">
            <button type="button" class="btn btn-primary" (click)="save()">Guardar cambios</button>
        </div>
    </div>

    <div class="payroll-config-panel" *ngIf="activeTab === 'generales'">
    <div class="payroll-config-header">
        <h4 class="mb-0">Configuración general</h4>
        <p class="mb-0">Define los parametros principales para el calculo de nomina</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="save()">
        <div class="cfg-row cfg-row-3">
            <div class="tab-card">
                <div class="tab-card-header">
                    <span class="tab-icon-badge" style="background:#fdebce;"><img src="assets/img/icons/cfg-setting-01.svg" alt=""></span>
                    <h5>Datos generales</h5>
                </div>

                <div class="field-col">
                    <label class="field-label">Numero de nomina</label>
                    <input type="number" class="field-input" formControlName="payroll_number">
                </div>
                <div class="field-col">
                    <label class="field-label">Periodicidad</label>
                    <select class="field-select" formControlName="periodicity">
                        <option value="">Seleccionar</option>
                        <option *ngFor="let opt of periodicityOptions" [value]="opt">{{opt}}</option>
                    </select>
                </div>
                <div class="field-col">
                    <label class="field-label">Dias de pago</label>
                    <input type="number" class="field-input" formControlName="payment_days">
                </div>
            </div>

            <div class="tab-card">
                <div class="tab-card-header">
                    <span class="tab-icon-badge" style="background:#caf4e5;"><img src="assets/img/icons/inc-calendar-03.svg" alt=""></span>
                    <h5>Fechas y días</h5>
                </div>

                <div class="field-col">
                    <label class="field-label">Primer dia de pago</label>
                    <input type="date" class="field-input" formControlName="first_payment_date">
                </div>
                <div class="field-col">
                    <label class="field-label">Días por año</label>
                    <input type="number" class="field-input" formControlName="days_per_year">
                </div>
                <div class="field-col">
                    <label class="field-label">Dias de la semana</label>
                    <select class="field-select" formControlName="week_days">
                        <option [ngValue]="null">Seleccionar</option>
                        <option *ngFor="let d of weekDaysOptions" [ngValue]="d">{{d}}</option>
                    </select>
                </div>
            </div>

            <div class="tab-card">
                <div class="tab-card-header">
                    <span class="tab-icon-badge" style="background:#eee7fe;"><img src="assets/img/icons/cfg-calculator.svg" alt=""></span>
                    <h5>Tipo de cálculo</h5>
                </div>

                <div class="field-col">
                    <label class="field-label">Tipo de cálculo</label>
                    <select class="field-select" formControlName="calculation_type">
                        <option value="">Seleccionar</option>
                        <option *ngFor="let opt of calculationTypeOptions" [value]="opt">{{opt}}</option>
                    </select>
                </div>

                <div class="doc-info-banner">
                    <img src="assets/img/icons/doc-info.svg" alt="">
                    <p>El tipo de calculo determina la manera en que se generan los acumulados y las persepciones</p>
                </div>
            </div>
        </div>

        <div class="cfg-row cfg-row-3">
            <div class="tab-card">
                <div class="tab-card-header">
                    <span class="tab-icon-badge" style="background:#fce7f3;"><img src="assets/img/icons/cfg-money-02.svg" alt=""></span>
                    <h5>Salario</h5>
                </div>

                <div class="field-col">
                    <label class="field-label">Salario minimo (SM)</label>
                    <input type="number" step="0.01" class="field-input" formControlName="minimum_wage">
                </div>
                <div class="field-col">
                    <label class="field-label">UMA diario</label>
                    <input type="number" step="0.01" class="field-input" formControlName="uma_daily">
                </div>
                <div class="field-col">
                    <label class="field-label">Jornada de trabajo</label>
                    <div class="field-input-icon">
                        <input type="number" step="0.5" class="field-input" formControlName="work_shift_hours">
                        <img src="assets/img/icons/cfg-clock-01.svg" alt="">
                    </div>
                </div>
            </div>

            <div class="tab-card">
                <div class="tab-card-header">
                    <span class="tab-icon-badge" style="background:#cce4ff;"><img src="assets/img/icons/cfg-briefcase-01.svg" alt=""></span>
                    <h5>Subsidio para el empleo</h5>
                </div>

                <label class="cfg-checkbox-row">
                    <input type="checkbox" formControlName="employment_subsidy_enabled">
                    Subs. empleo 2024
                </label>

                <div class="field-col">
                    <label class="field-label">UMA mensual</label>
                    <input type="number" step="0.01" class="field-input" formControlName="uma_monthly">
                </div>
                <div class="field-col">
                    <label class="field-label">Cuota mensual</label>
                    <input type="number" step="0.01" class="field-input" formControlName="monthly_quota">
                </div>
                <div class="field-col">
                    <label class="field-label">Ingreso limite</label>
                    <input type="number" step="0.01" class="field-input" formControlName="income_limit">
                </div>
            </div>

            <div class="tab-card">
                <div class="tab-card-header">
                    <span class="tab-icon-badge" style="background:#ffcccf;"><img src="assets/img/icons/cfg-license-maintenance.svg" alt=""></span>
                    <h5>Tablas del sistema</h5>
                </div>

                <div class="field-col">
                    <label class="field-label">I.S.R Mes</label>
                    <input type="number" class="field-input" formControlName="isr_month">
                </div>
                <div class="field-col">
                    <label class="field-label">I.S.R Año</label>
                    <input type="number" class="field-input" formControlName="isr_year">
                </div>
                <div class="field-col">
                    <label class="field-label">Salario diario integrado</label>
                    <input type="number" class="field-input" formControlName="integrated_daily_salary">
                </div>
                <div class="field-col">
                    <label class="field-label">Vacaciones</label>
                    <input type="number" class="field-input" formControlName="vacation_days">
                </div>
            </div>
        </div>

        <div class="tab-card">
            <div class="tab-card-header">
                <span class="tab-icon-badge" style="background:#ccf0ff;"><img src="assets/img/icons/cfg-setting-05.svg" alt=""></span>
                <h5>Parametros para calculo del I.S.R</h5>
            </div>

            <div class="cfg-isr-row">
                <div class="cfg-isr-col">
                    <label class="field-label">Cálculo del factor de mensualización</label>

                    <label class="cfg-checkbox-row">
                        <input type="radio" name="monthly_factor_calculation" [checked]="form.get('monthly_factor_calculation')?.value === 'isr_law'"
                            (change)="setMonthlyFactorCalculation('isr_law')">
                        De acuerdo a la Ley del I.S.R (30.4)
                    </label>
                    <label class="cfg-checkbox-row">
                        <input type="radio" name="monthly_factor_calculation" [checked]="form.get('monthly_factor_calculation')?.value === 'days_of_year'"
                            (change)="setMonthlyFactorCalculation('days_of_year')">
                        En base a los días del año
                    </label>

                    <div class="field-col">
                        <label class="field-label">I.S.R para salario minimo (SM)</label>
                        <select class="field-select" formControlName="isr_minimum_wage">
                            <option value="">Seleccionar</option>
                            <option *ngFor="let opt of isrMinimumWageOptions" [value]="opt">{{opt}}</option>
                        </select>
                    </div>
                </div>

                <div class="cfg-isr-divider"></div>

                <div class="cfg-isr-col">
                    <div class="field-col">
                        <label class="field-label">% Lim. Impuesto Loc.</label>
                        <input type="number" step="0.01" class="field-input" formControlName="local_tax_limit_percentage">
                    </div>
                </div>
            </div>
        </div>

        <div class="cfg-row cfg-row-2">
            <div class="tab-card">
                <div class="tab-card-header">
                    <span class="tab-icon-badge" style="background:#fef3d4;"><img src="assets/img/icons/cfg-user-shield-01.svg" alt=""></span>
                    <h5>Parametros de prevención social</h5>
                </div>

                <div class="field-col">
                    <label class="field-label">Limite en veces UMA</label>
                    <input type="number" class="field-input" formControlName="social_prevision_uma_limit">
                </div>

                <label class="cfg-checkbox-row">
                    <input type="checkbox" formControlName="isr_includes_limit">
                    I.S.R incluye limite de
                </label>
            </div>

            <div class="tab-card">
                <div class="tab-card-header">
                    <span class="tab-icon-badge" style="background:#e8fcf7;"><img src="assets/img/icons/inc-sun.svg" alt=""></span>
                    <h5>Vacaciones y prima vacacional</h5>
                </div>

                <label class="cfg-checkbox-row">
                    <input type="checkbox" formControlName="breakdown_vacation_payment">
                    Desglosar pago de vacaciones
                </label>
                <label class="cfg-checkbox-row">
                    <input type="checkbox" formControlName="automatic_vacation_payment">
                    Pago automatico
                </label>
                <label class="cfg-checkbox-row cfg-checkbox-disabled">
                    <input type="checkbox" formControlName="anniversary_completion">
                    Por cumplimiento de aniversario
                </label>
                <label class="cfg-checkbox-row cfg-checkbox-disabled">
                    <input type="checkbox" formControlName="complementary_expiration">
                    Complementaria por vencimiento
                </label>
            </div>
        </div>

        <div class="tab-save-bar" *ngIf="canDo('Editar')">
            <button type="submit" class="btn btn-primary">Guardar cambios</button>
        </div>
    </form>
    </div>
</div>
